import React, { useState } from 'react';
import { Check, Award, Video, Globe, FileCheck, Users, Play } from 'lucide-react';
import { VideoModal } from './VideoModal';
const reasons = ['User-friendly platform designed for non-techies', 'Arizona-based instruction relevant to your business', 'Expert-led education with real-world examples', 'Friendly local support team available by phone, text, email and chat', 'Competitive pricing'];
const renewalFeatures = [{
  icon: Award,
  text: 'ADRE-approved continuing education courses'
}, {
  icon: Video,
  text: 'On-Demand, Zoom, and In-Person classroom formats'
}, {
  icon: Globe,
  text: 'Courses focused on Arizona real estate information only'
}, {
  icon: Users,
  text: 'Local Arizona-based support team'
}];
export function WhyDesertSage() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return <section className="py-20 relative overflow-hidden" data-id="element-644" data-mp="4q04vb3piy00">
      {/* Background Image */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rHkPcQf6JAvCmJf8o15AXs/why-bg2.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'top'
    }} data-id="element-645" data-mp="3g4e0bpvl7lcl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-646" data-mp="3pwa4nio9o7p9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-647" data-mp="3l2fkyf8nvsq6">
          {/* Left Content Card */}
          <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8 border border-gray-100" data-id="element-648" data-mp="2ru7mysknyfe">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 leading-snug" data-id="element-649" data-mp="3uta59e2cki8z">
              Why Arizona Agents Choose
              <br data-id="element-650" data-mp="7p3se150nlww" />
              <span className="text-brand-purple-600 whitespace-nowrap" data-id="element-651" data-mp="7okldfgwmhxn">
                Desert Sage Seminars
              </span>
            </h2>
            <p className="text-base text-gray-600 mb-6 leading-relaxed" data-id="element-652" data-mp="2ehecqv0m09qr">
              We understand that license renewal can be stressful. That's why we
              have built our entire platform around simplicity, compliance, and
              local expertise. We are not a big national chain—we are Arizona
              real estate experts helping our peers succeed.
            </p>

            <ul className="space-y-3" data-id="element-653" data-mp="mcfpcfmyduxy">
              {reasons.map((reason, index) => <li key={index} className="flex items-start" data-id="element-654" data-mp="reevfxa2v5yl" data-mpi={index}>
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-655" data-mp="wcgdqfzoj190">
                    <Check className="w-3 h-3 text-green-600" data-id="element-656" data-mp="119qa6flhkd6c" />
                  </div>
                  <span className="ml-3 text-sm text-gray-700 font-medium" data-id="element-657" data-mp="162sury8accae">
                    {reason}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Side - License Renewal Info Card */}
          <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-8 border border-gray-100" data-id="element-658" data-mp="1f0lc17xkhu0f">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 leading-snug" data-id="element-659" data-mp="1jz6d19kn8hpx">
              Arizona Real Estate License Renewal
              <br data-id="element-660" data-mp="1p63coxhv7bz5" />
              At a Glance
            </h2>
            <p className="text-base text-gray-600 mb-6 leading-relaxed" data-id="element-661" data-mp="1p8pjuw0ufpgu">
              Arizona real estate agents must complete approved continuing
              education each two-year renewal cycle to stay compliant with the
              Arizona Department of Real Estate (ADRE). Desert Sage Seminars
              makes license renewal simple with ADRE-approved courses designed
              specifically for Arizona agents.
            </p>

            <ul className="space-y-3" data-id="element-662" data-mp="2352rldfksci4">
              {renewalFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return <li key={index} className="flex items-start" data-id="element-663" data-mp="2vm6rcnu26qak" data-mpi={index}>
                    <div className="flex-shrink-0 w-5 h-5 rounded-full bg-brand-purple-100 flex items-center justify-center mt-0.5" data-id="element-664" data-mp="2vojhho9z06yp">
                      <Icon className="w-3 h-3 text-brand-purple-600" data-id="element-665" data-mp="2bdyq6odu2zts" />
                    </div>
                    <span className="ml-3 text-sm text-gray-700 font-medium" data-id="element-666" data-mp="2gcigt23dgzsh">
                      {feature.text}
                    </span>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} videoId="OhJuESLnDqk" title="Desert Sage Seminars — Welcome" data-id="element-667" data-mp="26gfe9v4lyz50" />
    </section>;
}